"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAudience = setAudience;
exports.addFilter = addFilter;
exports.removeFilter = removeFilter;
exports.updateFilter = updateFilter;
exports.updateGroup = updateGroup;
exports.addGroup = addGroup;
exports.addHideGroup = addHideGroup;
exports.removeGroup = removeGroup;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _immutable = require("immutable");

var _Dynos = require("lead-flows-ui/selectors/Dynos");

var _Filters = _interopRequireDefault(require("lead-flows-ui/constants/AudienceTargeting/Filters"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _AudiencePaths = require("lead-flows-ui/constants/AudienceTargeting/AudiencePaths");

var _FilterRecord = _interopRequireDefault(require("lead-flows-ui/constants/AudienceTargeting/FilterRecord"));

var _AudienceTargetingUtils = require("lead-flows-ui/utils/AudienceTargetingUtils");

var _DynoEditor = require("lead-flows-ui/actions/DynoEditor");

function setAudience(filter) {
  var autosave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    dispatch((0, _DynoEditor.updateDyno)({
      audience: {
        filter: filter
      }
    }, autosave));
  };
}

function addFilter(path) {
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes.ADD_AUDIENCE_FILTER,
      payload: path
    });
    var audienceFilter = (0, _immutable.fromJS)((0, _Dynos.getAudienceFilter)(getState()));
    var values = audienceFilter.getIn(path).get('values');
    var type = values.getIn([0, 'type']);
    var filter = new _FilterRecord.default({
      type: type
    });
    var newAudienceFilter = audienceFilter.setIn([].concat((0, _toConsumableArray2.default)(path), ['values', values.size]), filter);
    dispatch(setAudience(newAudienceFilter));
  };
}

function removeFilter(path) {
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes.REMOVE_AUDIENCE_FILTER,
      payload: path
    });
    var groupPath = path.slice(0, path.length - 2);
    var audienceFilter = (0, _immutable.fromJS)((0, _Dynos.getAudienceFilter)(getState()));
    var group = audienceFilter.getIn(groupPath);
    var isLastItem = group.get('values').size === 1;
    var newAudienceFilter = isLastItem ? audienceFilter.removeIn(groupPath) : audienceFilter.removeIn(path);
    dispatch(setAudience(newAudienceFilter, true));
  };
}

function updateFilter(path, property, value) {
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes.UPDATE_AUDIENCE_FILTER,
      payload: {
        path: path,
        value: value
      }
    });
    var audienceFilter = (0, _immutable.fromJS)((0, _Dynos.getAudienceFilter)(getState()));
    var filter = audienceFilter.getIn(path);
    var newFilter = filter.set(property, value);

    if (property === 'type') {
      newFilter = newFilter.set('operator', _Filters.default[value].operators[0]);
      newFilter = newFilter.set('values', _Filters.default[value].defaultValue);
    }

    var newAudienceFilter = audienceFilter.setIn(path, newFilter);
    dispatch(setAudience(newAudienceFilter, true));
  };
}

function updateGroup(rootGroup, index, updatedGroup) {
  var autosave = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes.UPDATE_AUDIENCE_GROUP,
      payload: {
        rootGroup: rootGroup,
        index: index,
        updatedGroup: updatedGroup,
        autosave: autosave
      }
    });
    var filter = (0, _immutable.fromJS)((0, _Dynos.getAudienceFilter)(getState()));
    var group = (0, _AudienceTargetingUtils.selectGroup)(filter, rootGroup).get('values');
    var updatedFilter = (0, _AudienceTargetingUtils.updateGroupValues)(filter, rootGroup, group.set(index, updatedGroup));
    dispatch(setAudience(updatedFilter, autosave));
  };
} // TODO: refactor to use path instead of rootGroup


function addGroup(rootGroup) {
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes.ADD_AUDIENCE_GROUP,
      payload: rootGroup
    });
    var filter = (0, _immutable.fromJS)((0, _Dynos.getAudienceFilter)(getState()));
    var group = (0, _AudienceTargetingUtils.selectGroup)(filter, rootGroup).get('values');
    var newGroup = group.push((0, _AudienceTargetingUtils.getNewFilterGroup)());
    var updatedFilter = (0, _AudienceTargetingUtils.updateGroupValues)(filter, rootGroup, newGroup);
    dispatch(setAudience(updatedFilter));
  };
}

function addHideGroup() {
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes.ADD_HIDE_AUDIENCE
    });
    var hideGroupPath = [].concat((0, _toConsumableArray2.default)(_AudiencePaths.HIDE_GROUP_PATH), ['values', 0]);
    var audience = (0, _immutable.fromJS)((0, _Dynos.getAudience)(getState()));
    var newAudience = audience.setIn(hideGroupPath, (0, _AudienceTargetingUtils.getDefaultBlankFilter)());
    dispatch(setAudience(newAudience.get('filter')));
  };
}

function removeGroup(rootGroup, index) {
  return function (dispatch, getState) {
    dispatch({
      type: _ActionTypes.REMOVE_AUDIENCE_GROUP,
      payload: {
        rootGroup: rootGroup,
        index: index
      }
    });
    var filter = (0, _immutable.fromJS)((0, _Dynos.getAudienceFilter)(getState()));
    var group = (0, _AudienceTargetingUtils.selectGroup)(filter, rootGroup).get('values');
    var newGroup = group.remove(index);
    var updatedFilter = (0, _AudienceTargetingUtils.updateGroupValues)(filter, rootGroup, newGroup);
    dispatch(setAudience(updatedFilter, true));
  };
}